import React from 'react';

/**
 * ProgressBar Component
 * Shows quiz completion progress with animated width transition
 * 
 * @param {number} percentage - Progress percentage (0-100)
 */
export default function ProgressBar({ percentage }) {
  return (
    <div className="w-full bg-gray-700 h-1 rounded-full overflow-hidden">
      <div 
        className="h-full bg-gradient-to-r from-teal-accent to-thryv-green transition-[width] duration-300 ease-out"
        style={{ width: `${percentage}%` }}
        role="progressbar"
        aria-valuenow={percentage}
        aria-valuemin="0"
        aria-valuemax="100"
        aria-label={`Quiz progress: ${percentage}%`}
      />
    </div>
  );
}

